import {KeyCode} from '~/src/utilities/constants/keyboard';

const getKeyCodeFromEvent = (event) => {
    if (event.code) {
        return event.code;
    }

    switch (event.keyCode || event.which) {
        case 27:
            return KeyCode.ESC;
        case 37:
            return KeyCode.LEFT;
        case 39:
            return KeyCode.RIGHT;
        default:
            return null;
    }
};

export {getKeyCodeFromEvent};
